import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"plantuml"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M8 3V6.5H3V3H8Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 3V6.5H16V3H21Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M8 17.5V21H3V17.5H8Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 17.5V21H16V17.5H21Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.5 13.5V17.5M5.5 13.5H18.5M5.5 13.5V10M18.5 13.5V17.5M18.5 13.5V10M5.5 10V6.50003M5.5 10H18.5M18.5 10V6.50003M16 17.5H21V21.0002H16V17.5ZM3 17.5H8V21.0002H3V17.5ZM16 6.50016H21V3H16V6.50016ZM3 6.50016H8V3H3V6.50016Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Plantuml = Vue.extend<IconProps>({
  name: 'PlantumlIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'plantuml',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Plantuml;
